import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  DrawingManager,
  Circle,
} from "@react-google-maps/api";
import { Button } from "primereact/button";

const libraries = ["drawing"];

export default function CircleGeofenceMap({direction, setGeograph, navigate}) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyCLdJH2r1Lue1d_rZEDRQv1EYCShhRxETY",
    libraries,
  });

  const [center, setCenter] = useState({
    lat: 51.5074,
    lng: -0.1278,
  });

  const [circleData, setCircleData] = useState(null);
  const mapRef = useRef(null);


  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const userLocation = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        setCenter(userLocation);
        setCircleData({
            lat: userLocation.lat,
            lng: userLocation.lng,
            radius: 50,
        })

        if (mapRef.current) {
          mapRef.current.panTo(userLocation);
        }
      },
      () => console.log("Location permission denied")
    );
  }, []);

  const onMapLoad = (map) => {
    mapRef.current = map;
  };

  const onCircleComplete = (circle) => {
    circle.setMap(null);
    const data = {
      lat: circle.getCenter().lat(),
      lng: circle.getCenter().lng(),
      radius: circle.getRadius(),
    };

    setCircleData(data);
  };

  const HandleNext = () => {
    setGeograph(JSON.stringify(circleData, null, 2))
    navigate(7)
  }

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
    <div>
      <h3 style={{ color: "#6e6e6e", fontWeight:500}}>{`When I ${direction} this location`}</h3>
      <br/>
      <GoogleMap
        center={center}
        zoom={17}
        onLoad={onMapLoad}
        mapContainerStyle={{ width: "50vw", height: "30vw" }}
      >
        <Marker position={center} />

        <DrawingManager
          onCircleComplete={onCircleComplete}
          options={{
            drawingControl: true,
            drawingControlOptions: {
              drawingModes: ["circle"],
            },
            circleOptions: {
              fillColor: "#FF0000",
              fillOpacity: 0.2,
              strokeWeight: 2,
              editable: true,
            },
          }}
        />

        {circleData && (
          <Circle
            center={{ lat: circleData.lat, lng: circleData.lng }}
            radius={circleData.radius}
          />
        )}
      </GoogleMap>
        <br/>
        
    </div>

    <div style={{width:"100%", display:"flex", flexDirection:"row", justifyContent: "flex-end"}}>
            <Button label="Next" severity="success" onClick={() => HandleNext()}/>
    </div>
    </>
  );
}